export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Consortium.vue?vue&type=template&id=19f112be&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/usage/sections/Consortium.vue?vue&type=template&id=19f112be&scoped=true&
// module id = 1368
// module chunks = 0